import styled from '@emotion/styled'
import { isMobile } from '@const/device'

const DesktopWrapper = styled.div`
  padding: 0;
`
const MobileWrapper = styled.div`
  padding: 0;
`
export const Wrapper = isMobile ? MobileWrapper : DesktopWrapper

export const FilterCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 44px;
  margin-left: 5px;

  .ant-checkbox-wrapper {
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: 14px;
  }
`

export const TabContent = styled.div`
  padding-top: 20px;
  padding-bottom: 0;
  padding-left: ${() => (isMobile ? '10px' : '20px')};
  padding-right: ${() => (isMobile ? '10px' : '20px')};
`

export const PlaceholderText = styled.p`
  color: #666;
  font-size: 14px;
`
